import {get} from "lodash"
import BaseService from "./Base"

type KonductorGetAllConversation = {
    filter: {
        search?: string
    }
    pagination?: {
        page: number
        pageSize: number
    }
}

export type KonductorChatbotConfig = {
    frontendBaseUrl: string
    chatbotId: string
    chatbotSlug: string
    additionalParams: Record<string, string>
}

class KonductorService extends BaseService {
    async getAllConversations(data: KonductorGetAllConversation): Promise<any> {
        const response = await this.post("/v1/konductors/get-conversations", data)
        return get(response, "data.data", [])
    }

    async getChatbotConfig(): Promise<KonductorChatbotConfig | null> {
        const response = await this.post("/v1/konductors/config", {})
        return get(response, "data.data", null)
    }
}

export default KonductorService
